import { GeoJson } from '@ais-ui/api-spec/shapes';

import { useShapesEdit } from '@ais-ui/api';
import { SaveShapeGroupDialog } from './SaveShapeGroupDialog';

interface BaseCreateOrEditShapeGroupProps {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

interface EditShapeGroupProps extends BaseCreateOrEditShapeGroupProps {
  shape: GeoJson;
}

export function EditShapeGroup(props: EditShapeGroupProps) {
  const { mutate, error } = useShapesEdit();

  return (
    <SaveShapeGroupDialog
      showDialog={props.showDialog}
      setShowDialog={props.setShowDialog}
      mutate={mutate}
      action="edit"
      shape={props.shape}
    />
  );
}
